// extracted by mini-css-extract-plugin
export default {"filterBar":"TaskFilters_filterBar__7Fv8u","filterSelect":"TaskFilters_filterSelect__O6esV"};